import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    // flex: 1,
    paddingVertical: 15,
    alignItems: 'center',
  },
  emptyText: {
    textAlign: 'center',
  },
});